import { setMode } from '@stencil/core';

export default function (): any {
  setMode((elm) => {
    return (elm as any).theme || elm.getAttribute('theme') || 'default';
  });
}
